export const ROLE_TYPES = {
  GroupMember: 'GROUP_MEMBER',
  IncidentPosition: 'INCIDENT_POSITION',
  IncidentDefault: 'INCIDENT_DEFAULT',
} as const;

export type RoleType = (typeof ROLE_TYPES)[keyof typeof ROLE_TYPES];
